import {Inject, Injectable, InjectionToken} from '@angular/core';
import {StorageService} from 'ngx-webstorage-service';
// @ts-ignore
import * as CryptoJS from 'crypto-js';
import {IApiToken, IBookingDefaults} from '../main/settings/settings.service';

export const USER_INFO_STORAGE =
    new InjectionToken<StorageService>('USER_INFO_STORAGE');

export interface IAuthResponse {
    bookeng_app_token?: string
    user_id?: number;
    id?: string | undefined;
    time_zone_override?: string;
    last_name: string;
    first_name: string;
    email: string;
    org_id: number;
    billing_entity_id: number;
    time_zone: string;
    sys_admin: boolean;
    ops_group: boolean;
    theme?: string;
    admin_group: boolean;
    hide_private_viewer_dropdown?: number;
    hide_mlt?: number;
    hd?: string;
    read_only_user: boolean;
    hide_consumers_manager_view?: number;
    api_token?: IApiToken;
    developer?: number;
    allow_summary?: number;
    booking_defaults?: IBookingDefaults;
    be_booking_defaults?: IBookingDefaults;
    allow_personal_permanent_link: number;
    allow_ics_calendar: number;
    personal_permanent_guid?: string;
    ics_calendar_guid?: string;
    allow_confirmed_emails?: number;
    allow_canceled_emails?: number;
    allow_received_emails?: number;
    curr_billing_entity_id?: number;
    allow_transcript_tools?: number
}

const STORAGE_KEY = 'app_user_info';

@Injectable()
export class UserInfoStorageService {

    constructor(@Inject(USER_INFO_STORAGE) private storage: StorageService) {
    }

    get(): IAuthResponse | null {
        return this.storage.get(STORAGE_KEY);
    }

    has(): boolean {
        return this.storage.has(STORAGE_KEY);
    }

    set(data: IAuthResponse): void {
        if (data) {
            // let ciphertext = CryptoJS.AES.encrypt({email: data.email}, 'hvj-ABU0adw_xjw0eyksdvsdvsdvhvj-ABU0adw_xjwk').toString();
            // localStorage.setItem('user_email', data.email);
            const encrypted = CryptoJS.AES.encrypt(data.email, 'hvjABU0adw_xjw0eyksdvsdvsdvhvjABU0adw_xjwk');
            localStorage.setItem('app_state', encrypted);
            return this.storage.set(STORAGE_KEY, data);
        }
    }

    empty() {
        this.storage.remove(STORAGE_KEY);
    }
}
